module.exports = __webpack_public_path__ + "e2a57a0de292da6b45f6f72fde68cc7c.svg";